import { useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';

function TokenRefund({ apiUrl }) {
    const [tokenRefund, setTokenRefund] = useState({
        operation: properties.OPERATIONS.tokenrufund,
        timestamp: "",
        transactionid: transidgenerator(),
        vendorid: properties.VENDOR_ID,
        method: properties.HTTP_METHOD,
        password: properties.PASSWORD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        token: properties.TOKEN,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        security: ""
    });

    var region = [];

    for (var property in properties.REGIONS) {
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;

    function isNotNullCheck(e, field) {
        if (e === "" || !e) {
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else {
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value, "WPG_transID");
        setTokenRefund({ ...tokenRefund, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value, "WPG_vendorID");
        setTokenRefund({ ...tokenRefund, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value, "vendorPwd");
        setTokenRefund({ ...tokenRefund, password: e.target.value });
    }

    function changeDesc(e) {
        setTokenRefund({ ...tokenRefund, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value, "WPG_value");
        setTokenRefund({ ...tokenRefund, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value, "WPG_currency");
        setTokenRefund({ ...tokenRefund, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value, "WPG_token");
        setTokenRefund({ ...tokenRefund, token: e.target.value });
    }

    function changePostCode(e) {
        setTokenRefund({ ...tokenRefund, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setTokenRefund({ ...tokenRefund, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value, "WPG_region");
        setTokenRefund({ ...tokenRefund, region: e.target.value });
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    }, []);

    function submitTokenRefundForm(e) {
        e.preventDefault();
        isNotNullCheck(tokenRefund.password, "vendorPwd");
        isNotNullCheck(tokenRefund.vendorid, "WPG_vendorID");
        isNotNullCheck(tokenRefund.transactionid, "WPG_transID");
        isNotNullCheck(tokenRefund.value, "WPG_value");
        isNotNullCheck(tokenRefund.token, "WPG_token");
        isNotNullCheck(tokenRefund.region, "WPG_region");
        isNotNullCheck(tokenRefund.currency, "WPG_currency");
        if (canSubmit) {
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if (tokenRefund.region === "NoR") {
                setTokenRefund({ ...tokenRefund, region: "" });
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#tokenrefund_timestamp").val(time);
            var digest = md5(time + tokenRefund.vendorid +
                tokenRefund.transactionid + tokenRefund.method + tokenRefund.description +
                tokenRefund.value + tokenRefund.currency + tokenRefund.region +
                tokenRefund.token + tokenRefund.postCode +
                tokenRefund.countryCode + tokenRefund.password);
            $("#tokenrefund_security").val(digest);
            $("#tokenrefundForm").attr('action', apiUrl).submit();
        }
    }

    var tokenRefundTemplate = (
        <div className="operation-form">
            <h2>Token Refund</h2>
            <form className="form-horizontal" method='post' id="tokenrefundForm" onSubmit={submitTokenRefundForm}>
                <input type="hidden" name="WPG_timestamp" id="tokenrefund_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="tokenrefund_security" value="" />
                <input type="hidden" name="WPG_operation" value={tokenRefund.operation} />
                <input type="hidden" name="WPG_method" value={tokenRefund.method} />
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={tokenRefund.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={tokenRefund.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={tokenRefund.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={tokenRefund.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={tokenRefund.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={tokenRefund.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={tokenRefund.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={tokenRefund.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_postcode" value={tokenRefund.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_countryCode" value={tokenRefund.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp /></span>
            </div>
        </div>
    );
    return tokenRefundTemplate;
}

export default TokenRefund;